import * as React from "react";
const SvgFiRrStamp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-stamp_svg__a)">
      <path
        fill="#062147"
        d="M21 24H3a1 1 0 0 1 0-2h18a1 1 0 1 1 0 2m3-6c0-2.757-2.243-5-5-5h-3a1 1 0 0 1-.766-.356.99.99 0 0 1-.22-.813c.58-3.334.985-6.555.985-7.831 0-2.206-1.794-4-4-4s-4 1.794-4 4c0 1.278.405 4.498.985 7.831a.98.98 0 0 1-.219.812.99.99 0 0 1-.766.357h-3c-2.757 0-5 2.243-5 5 0 .97.701 2 2 2H22c1.299 0 2-1.03 2-2M8 15c.888 0 1.725-.39 2.296-1.07a2.99 2.99 0 0 0 .659-2.442C10.401 8.307 9.999 5.157 9.999 4c0-1.103.897-2 2-2s2 .897 2 2c0 1.156-.402 4.305-.956 7.488a3 3 0 0 0 .66 2.443A3 3 0 0 0 15.999 15h3c1.654 0 3 1.346 3 3H2c0-1.654 1.346-3 3-3z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-stamp_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrStamp;
